import script from "./FilterProgressao.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterProgressao.vue?vue&type=script&setup=true&lang=js"

import "./FilterProgressao.vue?vue&type=style&index=0&id=0f9799c6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f9799c6"]])

export default __exports__